export const formatCount = (resultCount: number): string =>
  resultCount?.toLocaleString("en-GB", {
    maximumFractionDigits: 0,
  });